import { postRequest, formDataRequest } from "../libs/AxiosService.util";

export async function serviceHqDashboardInfoDetails(params) {
  return await postRequest("sales/target/employee/dashboard", params);
}
export async function serviceHqDashboardStatusDetails(params) {
  return await postRequest("sales/target/hq/overall", params);
}
export async function serviceHqDashboardCategoryDetail(params) {
  return await postRequest("sales/target/hq/category", params);
}
export async function serviceHqDashboardRegionTableData(params) {
  return await postRequest("sales/target/hq/region", params);
}
export async function serviceHqDashboardEmployee(params) {
  return await postRequest("sales/target/hq/employee", params);
}
export async function serviceHqDashboardBrand(params) {
  return await postRequest("sales/target/hq/brand", params);
}
export async function serviceHqDashboardExport(params) {
  return await postRequest("sales/target/hq/region/export", params);
}
